import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Typography, Paper, useMediaQuery, useTheme } from "@mui/material";
import FacebookCircularProgress from "../../shared/shared/Loading";
import dayjs from "dayjs";

export default function PromotionUpliftBoxplot() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Responsive breakpoints
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));

  const colorPalette = [
    "#255e91", 
    "#53b5ff", 
    "#fbc210", 
    "#666666",
    "#ff6b6b", 
    "#4ecdc4", 
    "#ff9f43", 
    "#5f27cd"
  ];

  // const fetchData = async () => {
  //   if (!projectId) {
  //     setError("Project ID not found.");
  //     setLoading(false);
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     setError(null);
      
  //     const apiUrl = `${getUrl()}/strategy_creation/uplift_distribution?project_id=${projectId}&time_period=${timePeriod}&target=${target}`;
      
  //     console.log("API URL:", apiUrl);
      
  //     const response = await fetch(apiUrl, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         "x-cors-api-key": "temp_8c8f91f122df0ef9daa49a6701f13f76",
  //       },
  //     });
        
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status} - ${response.statusText}`);
  //     }
        
  //     const apiData = await response.json();

  //     console.log("API response:", apiData);

  //     if (!apiData || typeof apiData !== "object") {
  //       throw new Error("Invalid API response format");
  //     }

  //     const transformedData = apiData.promo_offer_code.map((promoCode, index) => ({
  //       x: promoCode,
  //       y: [
  //         apiData.min[index],
  //         apiData.q1[index],
  //         apiData.median[index],
  //         apiData.q3[index],
  //         apiData.max[index]
  //       ],
  //       fillColor: colorPalette[index % colorPalette.length]
  //     }));

  //     setData(transformedData);
  //     setError(null);
  //   } catch (err) {
  //     console.error(err);
  //     setError("Failed to load data");
  //     setData([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  // }, [projectId, timePeriod, target]);

  useEffect(() => {
    const staticData = [
      {
        "promo_offer_code":"CP",
        "Time_Granularity":"P24M",
        "value_sales":45518769.5700000003,
        "volume_sales":4489425.0999999996,
        "promo_count":55765,
        "year":2023,
        "baseline_volume":4205289.5,
        "uplift_volume":284135.599999999,
        "uplift_pct":6.7566240089,
        "min":6.7566240089,
        "q1":6.7566240089,
        "median":6.7566240089,
        "q3":6.7566240089,
        "max":6.7566240089,
        "productivity ratio":5.0952317762
      },
      {
        "promo_offer_code":"IP",
        "Time_Granularity":"P24M",
        "value_sales":408885.54,
        "volume_sales":31959.7,
        "promo_count":1690,
        "year":2023,
        "baseline_volume":28729.8984375,
        "uplift_volume":3229.8015625,
        "uplift_pct":11.2419525935,
        "min":11.2419525935,
        "q1":11.2419525935,
        "median":11.2419525935,
        "q3":11.2419525935,
        "max":11.2419525935,
        "productivity ratio":1.9111251849
      },
      {
        "promo_offer_code":"IS",
        "Time_Granularity":"P24M",
        "value_sales":2067252.1599999999,
        "volume_sales":175313.1,
        "promo_count":4281,
        "year":2023,
        "baseline_volume":171948.0,
        "uplift_volume":3365.1,
        "uplift_pct":1.9570451532,
        "min":1.9570451532,
        "q1":1.9570451532,
        "median":1.9570451532,
        "q3":1.9570451532,
        "max":1.9570451532,
        "productivity ratio":0.7860546601
      },
      {
        "promo_offer_code":"OC",
        "Time_Granularity":"P24M",
        "value_sales":2702586.8700000001,
        "volume_sales":266529.0,
        "promo_count":1341,
        "year":2023,
        "baseline_volume":198146.765625,
        "uplift_volume":68382.234375,
        "uplift_pct":34.5109011289,
        "min":34.5109011289,
        "q1":34.5109011289,
        "median":34.5109011289,
        "q3":34.5109011289,
        "max":34.5109011289,
        "productivity ratio":50.9934633669
      },
      {
        "promo_offer_code":"PX",
        "Time_Granularity":"P24M",
        "value_sales":83394774.4099999964,
        "volume_sales":9503921.1999999993,
        "promo_count":17226,
        "year":2023,
        "baseline_volume":8225198.0,
        "uplift_volume":1278723.1999999899,
        "uplift_pct":15.5464123782,
        "min":15.5464123782,
        "q1":15.5464123782,
        "median":15.5464123782,
        "q3":15.5464123782,
        "max":15.5464123782,
        "productivity ratio":74.2321606873
      },
      {
        "promo_offer_code":"CP",
        "Time_Granularity":"P12M",
        "value_sales":34966644.75,
        "volume_sales":3927528.0,
        "promo_count":73148,
        "year":2024,
        "baseline_volume":2440951.75,
        "uplift_volume":1486576.25,
        "uplift_pct":60.9015008183,
        "min":60.9015008183,
        "q1":60.9015008183,
        "median":60.9015008183,
        "q3":60.9015008183,
        "max":60.9015008183,
        "productivity ratio":20.3228557172
      },
      {
        "promo_offer_code":"IP",
        "Time_Granularity":"P12M",
        "value_sales":430564.65,
        "volume_sales":44176.4,
        "promo_count":1078,
        "year":2024,
        "baseline_volume":32837.6015625,
        "uplift_volume":11338.7984375,
        "uplift_pct":34.5299227044,
        "min":34.5299227044,
        "q1":34.5299227044,
        "median":34.5299227044,
        "q3":34.5299227044,
        "max":34.5299227044,
        "productivity ratio":10.5183658975
      },
      {
        "promo_offer_code":"IS",
        "Time_Granularity":"P12M",
        "value_sales":2270491.52,
        "volume_sales":258882.2,
        "promo_count":6369,
        "year":2024,
        "baseline_volume":167812.5625,
        "uplift_volume":91069.6375,
        "uplift_pct":54.2686650768,
        "min":54.2686650768,
        "q1":54.2686650768,
        "median":54.2686650768,
        "q3":54.2686650768,
        "max":54.2686650768,
        "productivity ratio":14.2988911132
      },
      {
        "promo_offer_code":"PX",
        "Time_Granularity":"P12M",
        "value_sales":86485990.4800000042,
        "volume_sales":12411834.0,
        "promo_count":26984,
        "year":2024,
        "baseline_volume":8602189.0,
        "uplift_volume":3809645.0,
        "uplift_pct":44.2869251071,
        "min":44.2869251071,
        "q1":44.2869251071,
        "median":44.2869251071,
        "q3":44.2869251071,
        "max":44.2869251071,
        "productivity ratio":141.1816261488
      }
    ];

    try {
      setLoading(true);
      
      const p12mData = staticData.filter(item => item.Time_Granularity === "P12M");
      
      const transformedData = p12mData.map((item, index) => ({
        x: item.promo_offer_code,
        y: [
          item.min,
          item.q1,
          item.median,
          item.q3,
          item.max
        ],
        fillColor: colorPalette[index % colorPalette.length]
      }));

      setData(transformedData);
      setError(null);
    } catch (err) {
      console.error(err);
      setError("Failed to load data");
      setData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // const handleRefresh = () => {
  //   fetchData();
  // };

  const handleRefresh = () => {
    window.location.reload();
  };

  const series = [
    {
      name: "Uplift Distribution",
      type: "boxPlot",
      data,
    },
  ];

  const options = {
    chart: {
      type: "boxPlot",
      toolbar: { show: false },
      fontFamily: "Barlow Semi Condensed, sans-serif",
      height: "100%",
    },
    plotOptions: {
      boxPlot: {
        colors: {
          upper: undefined,
          lower: undefined,
        },
        columnWidth: isSmallMobile ? "65%" : isMobile ? "60%" : "55%",
      },
    },
    colors: data.map((d) => d.fillColor),
    fill: {
      type: "solid",
      opacity: 0.9,
    },
    stroke: {
      colors: ["#333"],
      width: isSmallMobile ? 1 : isMobile ? 1.2 : 1.3,
    },
    xaxis: {
      type: "category",
      labels: {
        style: { 
          fontSize: isSmallMobile ? "10px" : isMobile ? "11px" : "12px",
          fontWeight: isSmallMobile ? "500" : "normal"
        },
        rotate: isSmallMobile ? -45 : isMobile ? -30 : -15,
      },
      title: {
        text: "Promotion Type",
        style: { 
          fontSize: isSmallMobile ? "11px" : isMobile ? "13px" : "14px", 
          fontWeight: "bold" 
        },
      },
    },
    yaxis: {
      title: {
        text: isSmallMobile ? "Volume Uplift (%)" : "Volume Uplift (%)",
        style: { 
          fontSize: isSmallMobile ? "11px" : isMobile ? "13px" : "14px", 
          fontWeight: "bold" 
        },
      },
      min: 0,
      tickAmount: isSmallMobile ? 3 : isMobile ? 4 : 5,
      labels: {
        style: {
          fontSize: isSmallMobile ? "9px" : isMobile ? "10px" : "11px"
        },
      },
    },
    grid: {
      borderColor: "#E0E0E0",
      strokeDashArray: isSmallMobile ? 2 : 4,
    },
    legend: { show: false },
    tooltip: {
      shared: false,
      intersect: true,
      style: {
        fontSize: isSmallMobile ? "11px" : "12px"
      },
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            height: 350,
          },
          plotOptions: {
            boxPlot: {
              columnWidth: "70%",
            },
          },
          xaxis: {
            labels: { 
              style: { fontSize: "10px" }, 
              rotate: -45 
            },
            title: {
              style: { fontSize: "11px" }
            }
          },
          yaxis: {
            labels: { 
              style: { fontSize: "9px" } 
            },
            title: {
              style: { fontSize: "11px" }
            }
          },
          stroke: {
            width: 1,
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 380,
          },
          plotOptions: {
            boxPlot: {
              columnWidth: "65%",
            },
          },
          xaxis: {
            labels: { 
              style: { fontSize: "11px" }
            },
            title: {
              style: { fontSize: "12px" }
            }
          },
          yaxis: {
            labels: { 
              style: { fontSize: "10px" } 
            },
            title: {
              style: { fontSize: "12px" }
            }
          },
        },
      },
    ],
  };

  return (
    <Box sx={{ 
      width: "100%", 
      minWidth: { xs: "400px", sm: "500px", md: "550px" },
      maxWidth: "100%",
      overflow: "hidden"
    }}>
      <Typography
        align="center"
        fontWeight={500}
        mb={1}
        sx={{ 
          fontSize: { xs: isSmallMobile ? "0.875rem" : "1rem", sm: "1.25rem" }, 
          pb: 2,
          px: { xs: 1, sm: 0 }
        }}
      >
        Distribution of Uplift by Promotion Type
      </Typography>

      {loading ? (
        <Paper
          elevation={2}
          sx={{
            p: { xs: 1, sm: 2 },
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
            borderRadius: { xs: 1, sm: 2 },
            boxShadow: { xs: 1, sm: 2 },
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="400px"
          >
            <FacebookCircularProgress loading={true} />
          </Box>
        </Paper>
      ) : error || data.length === 0 ? (
        <Paper
          elevation={2}
          sx={{
            p: { xs: 1, sm: 2 },
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
            borderRadius: { xs: 1, sm: 2 },
            boxShadow: { xs: 1, sm: 2 },
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="400px"
          >
            <FacebookCircularProgress
              loading={false}
              hasData={false}
              onRefresh={handleRefresh}
              message={error || "No data available"}
            />
          </Box>
        </Paper>
      ) : (
        <Paper
          elevation={2}
          sx={{
            p: { xs: 1, sm: 2 },
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
            borderRadius: { xs: 1, sm: 2 },
            boxShadow: { xs: 1, sm: 2 },
          }}
        >
          <Box sx={{ 
            width: "100%", 
            overflow: "auto",
            "&::-webkit-scrollbar": {
              width: "6px",
              height: "6px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
              borderRadius: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#c1c1c1",
              borderRadius: "3px",
              "&:hover": {
                background: "#9e9e9e",
              },
            },
          }}>
            <ReactApexChart
              options={options}
              series={series}
              type="boxPlot"
              height={isSmallMobile ? 350 : isMobile ? 400 : 420}
              width="100%"
            />
          </Box>
        </Paper>
      )}
    </Box>
  );
}